import React, { useEffect, useState, } from 'react';
import { ActivityIndicator, Text, View, } from 'react-native';
import { PlayerView as PlayerViewZapi } from '@zattoo/playback-sdk-react-native-zapi';
import { PlayerView } from '@zattoo/playback-sdk-react-native';
import { styles } from './styles';
import { useTafPlayerAdapter } from './use-taf-player';
import { ContainerType } from './player-container';
let tafConfiguration = {
    deviceUrl: 'ws://localhost:8002/ws/device',
};
export const tafSetUp = (configuration) => {
    tafConfiguration = configuration;
};
const TafSession = () => {
    const adapter = useTafPlayerAdapter(tafConfiguration);
    if (adapter.player !== null) {
        switch (adapter.player.getContainerType()) {
            case ContainerType.PLAYER_ZAPI:
                return (React.createElement(PlayerViewZapi, { player: adapter.player.getPlayerZapi(), style: {
                        width: '100%',
                        height: '100%',
                        flex: 1,
                    } }));
            case ContainerType.PLAYER:
                return (React.createElement(PlayerView, { player: adapter.player.getPlayer(), style: {
                        width: '100%',
                        height: '100%',
                        flex: 1,
                    } }));
            default:
                break;
        }
    }
    if (adapter.session !== null) {
        return (React.createElement(View, { style: styles.body },
            React.createElement(Text, { style: styles.description }, "Playback Test Automation Framework"),
            React.createElement(Text, { style: styles.text }, "Connected to taf"),
            adapter.session && (React.createElement(Text, { style: styles.text }, adapter.session.sessionId)),
            React.createElement(Text, { style: styles.description }, "Powered by Zattoo's Stream API and PlaybackSDK")));
    }
    return (React.createElement(View, { style: styles.body },
        React.createElement(Text, { style: styles.text },
            "Connecting...",
            '\n',
            tafConfiguration.deviceUrl),
        React.createElement(ActivityIndicator, { size: "large" })));
};
export const Taf = () => {
    const [isReady, setIsReady] = useState(false);
    useEffect(() => {
        if (!tafConfiguration.platformInit) {
            setIsReady(true);
            return;
        }
        tafConfiguration
            .platformInit()
            .then(() => {
            setIsReady(true);
        })
            .catch((error) => {
            console.error('Error during platform initialization:', error);
        });
    }, []);
    if (!isReady) {
        return (React.createElement(View, { style: styles.body },
            React.createElement(Text, { style: styles.text }, "Warming up..."),
            React.createElement(ActivityIndicator, { size: "large" })));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(TafSession, null)));
};
